export const SUPPORT_EMAIL = 'support@ivyclinicians.io';
